import { render, staticRenderFns } from "./DepartmantIcon.vue?vue&type=template&id=e82dcd42&"
import script from "./DepartmantIcon.vue?vue&type=script&lang=js&"
export * from "./DepartmantIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports